import React from "react";
import type {Theme} from '@mui/material/styles';
import {useTranslation} from "react-i18next";
import {commonStyles} from "../styles";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import NextLink from "next/link";
import Switch from "@mui/material/Switch";
import ListItemIcon from "@mui/material/ListItemIcon";

import Image from "next/image";

export interface Props {
    navigation: any
}

const EasyLangMobileToggleButton = (props: Props) => {
    const {t} = useTranslation();
    const navigationRoot = props?.navigation?.content?.site?.root || props?.navigation?.root;
    const button = navigationRoot?.easyLangToggleButton;
    const buttonLabel = navigationRoot?.easyLangToggleLabel?.easyLangToggleButtonLabel ?? t('easy_language_toggle_button_label');
    const buttonAriaLabel = t('easy_language_toggle_button_aria_label');
    const active = !!(navigationRoot?.easyLangToggleActive?.easyLangToggleButtonActive);
    const componentProp = NextLink;
    const height = "56px";
    const borderStyles = {borderBottom: (theme: Theme) => `1px solid ${theme.palette.divider}`};
    if (!button) {
        return null;
    }
    const href = button?.selfUrl;
    const image = active ? '/aufgeschlagenes-buch.svg' : '/aufgeschlagenes-buch-sw.svg';
    const txtStyle = active ? 'var(--sos-main)' : 'var(--primary-text)';

    return (button && href ? <ListItemButton
                data-cypress={`mobileMenuItem-easy-lang-mobile`}
                component={componentProp}
                href={href as string}
                sx={{
                    height,
                    ...commonStyles.menuItemLayout,
                    ...borderStyles,
                    "&:hover": commonStyles.hoverStyles,
                    ...commonStyles.activeStyles(false, true, false)
                }}
            >
                <ListItemIcon sx={{minWidth: 'auto', marginRight: '16px'}}>
                    <Image src={image} alt="" width={24} height={24}/>
                </ListItemIcon>
                <ListItemText
                    primary={buttonLabel}
                    slotProps={{
                        primary: {
                            ...commonStyles.menuItemTypographyProps(undefined),
                            sx: {
                                color: txtStyle,
                                ...commonStyles.menuItemTypographyProps(undefined).sx,
                                textDecoration: active ? 'underline' : 'none',
                                textDecorationThickness: active ? '2px' : 'initial',
                                textUnderlineOffset: active ? '2px' : 'initial'
                            }
                        }
                    }}
                />
                <Switch defaultChecked={active} aria-label={buttonAriaLabel}/>
            </ListItemButton> : null);
}
export default React.memo(EasyLangMobileToggleButton);
